module.exports = __webpack_public_path__ + "img/bath.5c6485c3.svg";